import { DriveRoles } from './client-roles';
import { isFeatureEnabled } from '../feature-flags';

const LABEL_WRITE_ROLES = [
  'CreateDriveLabels',
  'DeleteDriveLabels',
  'UpdateDriveLabelsStatus',
  'EditDriveLabels',
];

/**
 * The Drive roles to offer for the domain's feature flags, so every list of roles (the role
 * manager's permissions, the Logging page's permission filter) hides the same ones.
 *
 * - Can View Drive Labels needs driveLabelsRead.
 * - Create, Edit, Delete, Disable and Enable Drive Labels need driveLabelsRead and driveLabelsQ4,
 *   the same gate as the Create and Edit Label pages and the Label Manager's row and toolbar actions.
 */
export function getVisibleDriveRoles(
  features: Record<string, boolean> | null
): typeof DriveRoles {
  const labelsRead = isFeatureEnabled('driveLabelsRead', features);
  const labelsWrite = labelsRead && isFeatureEnabled('driveLabelsQ4', features);

  return Object.fromEntries(
    Object.entries(DriveRoles).filter(
      ([key]) =>
        (labelsRead || key !== 'CanViewDriveLabels') &&
        (labelsWrite || !LABEL_WRITE_ROLES.includes(key))
    )
  ) as typeof DriveRoles;
}
